import { Routes } from '@angular/router';
import { SitemapComponent } from './modules/sitemap/sitemap/sitemap.component';

export const routes: Routes = [

    {
        path: '',
        //  component: HomeComponent 
        loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)

    },

    {
        path: 'about-us',
        loadChildren: () => import('./modules/about-us/about-us.module').then(m => m.AboutUsModule)
    },
    {
        path: 'screenreader',
        loadChildren: () => import('./modules/screenreader/screenreader.module').then(m => m.ScreenreaderModule)
    },

    {
        path: 'new-application',
        //  loadChildren: () => import('./modules/new-application/new-application.module').then(m => m.NewApplicationModule)
        loadChildren: () => import('./modules/new-application-2026-27/new-application-2026-27.module').then(m => m.NewApplication202627Module)
    },

    {
        path: 'empolyee',
        loadChildren: () => import('./modules/empolyee/empolyee.module').then(m => m.EmpolyeeModule)

    },
    {
        path: 'applicants-status',
        loadChildren: () => import('./modules/applicants-status/applicants-status.module').then(m => m.ApplicantsStatusModule)
    },
    {
        path: 'new-documents',
        loadChildren: () => import('./modules/new-documents/new-documents.module').then(m => m.NewDocumentsModule)
    },

    {
        path: 'monthly-fund-distribution',
        loadChildren: () => import('./modules/monthly-fund-distribution/monthly-fund-distribution.module').then(m => m.MonthlyFundDistributionModule)
    },

    {
        path: 'gallery',
        loadChildren: () => import('./modules/gallery/gallery.module').then(m => m.GalleryModule)
    },
    {
        path: 'user-login',
        loadChildren: () => import('./modules/user-login/user-login.module').then(m => m.UserLoginModule)
    },
    {
        path: 'yojana-tapshil',
        loadChildren: () => import('./modules/Yojana-tapshil/yojana-tapshil.module').then(m => m.YojanaTapshilModule)

    },

    {
        path: 'govarddhan-govansh-yojana',
        loadChildren: () => import('./modules/govardhan-govansh-yojana/govardhan-govansh-yojana.module').then(m => m.GovardhanGovanshYojanaModule)
    },
    {
        path: 'revised/govardhan-govansh-application',
        loadChildren: () => import('./modules/govardhan-govansh-application/govardhan-govansh-application.module').then(m => m.GovardhanGovanshApplicationModule)
    },
    {
        path: 'govardhan-govansh-application-list',
        loadChildren: () => import('./modules/govardhan-govansh-application-list/govardhan-govansh-application-list.module').then(m => m.GovardhanGovanshApplicationListModule)
    },

    {
        path: 'govardhan-govansh-district-application-list',
        loadChildren: () => import('./modules/govardhan-govansh-district-application-list/govardhan-govansh-district-application-list.module').then(m => m.GovardhanGovanshDistrictApplicationListModule)
    },
    {
        path: 'admin-sanstha-attendance-verification-list',
        loadChildren: () => import('./modules/admin-sanstha-attendance-verification-list/admin-sanstha-attendance-verification-list.module').then(m => m.AdminSansthaAttendanceVerificationListModule)
    },
    {
        path: 'admin-sanstha-attendance-verification-list',
        loadChildren: () => import('./modules/admin-sanstha-attendance-verification-list/admin-sanstha-attendance-verification-list.module').then(m => m.AdminSansthaAttendanceVerificationListModule)
    },
    {
        path: 'admin-sanstha-attendance-verification',
        loadChildren: () => import('./modules/admin-sanstha-attendance-verification/admin-sanstha-attendance-verification.module').then(m => m.AdminSansthaAttendanceVerificationModule)
    },
    {
        path: 'screenreader',
        loadChildren: () => import('./modules/screenreader/screenreader.module').then(m => m.ScreenreaderModule)
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
        path: 'govardhan-dashboard',
        loadChildren: () => import('./modules/govardhan-dashboard/govardhan-dashboard.module').then(m => m.GovardhanDashboardModule)
    },
    {
        path: 'district-sanstha-verification-list',
        loadChildren: () => import('./modules/district-sanstha-verification-list/district-sanstha-verification-list.module').then(m => m.DistrictSansthaVerificationListModule)
    },
    {
        path: 'district-admin-attendance-verification',
        loadChildren: () => import('./modules/district-admin-attendance-verification/district-admin-attendance-verification.module').then(m => m.DistrictAdminAttendanceVerificationModule)
    },
    {
        path: 'application',
        loadChildren: () => import('./modules/application/application.module').then(m => m.ApplicationModule)
    },
    {
        path: 'applicants',
        loadChildren: () => import('./modules/applicants/applicants.module').then(m => m.ApplicantsModule)
    },
    {
        path: 'contact-us',
        loadChildren: () => import('./modules/contact-us/contact-us.module').then(m => m.ContactUsModule)

    },
    {
        path: 'zilha-nihay',
        loadChildren: () => import('./modules/zilha-nihay/zilha-nihay.module').then(m => m.ZilhaNihayModule)
    },
    {
        path: 'bank-report',
        loadChildren: () => import('./modules/bank-report/bank-report.module').then(m => m.BankReportModule)
    },

    {
        path: 'padtalni-ahval',
        loadChildren: () => import('./modules/padtalni-ahval/padtalni-ahval.module').then(m => m.PadtalniAhvalModule)
    },
    {
        path: 'antim-nivad',
        loadChildren: () => import('./modules/antim-nivad/antim-nivad.module').then(m => m.AntimNivadModule)
    },

    {
        path: 'joint-commissioner-list',
        loadChildren: () => import('./modules/joint-commissioner-list/joint-commissioner-list.module').then(m => m.JointCommissionerListModule)
    },
    {
        path: 'accountant-list',
        loadChildren: () => import('./modules/accountant-list/accountant-list.module').then(m => m.AccountantListModule)
    },
    {
        path: 'president-list',
        loadChildren: () => import('./modules/president-list/president-list.module').then(m => m.PresidentListModule)
    },
    {
        path: 'timetable',
        loadChildren: () => import('./modules/timetable/timetable.module').then(m => m.TimetableModule)
    },
    {
        path: 'sitemap',
        component: SitemapComponent,

    },
    {
        path: 'go-ten',
        loadChildren: () => import('./modules/go-ten/go-ten.module').then(m => m.GoTenModule)
    },
    {
        path: 'doc-reupload',
        loadChildren: () => import('./modules/doc-reupload/doc-reupload.module').then(m => m.DocReuploadModule)
    },
    {
        path: 'govardhan-doc-reupload',
        loadChildren: () => import('./modules/govardhan-doc-reupload/govardhan-doc-reupload.module').then(m => m.GovardhanDocReuploadModule)
    },
    {
        path: 'weekly-attendance-list',
        loadChildren: () => import('./modules/admin-weekly-attendance-list/admin-weekly-attendance-list.module').then(m => m.AdminWeeklyAttendanceListModule)
    },
    {
        path: 'attendance-dashboard',
        loadChildren: () => import('./modules/attendance-dashboard/attendance-dashboard.module').then(m => m.AttendanceDashboardModule)
    },

    {
        path: 'sanstha-all-details',
        loadChildren: () => import('./modules/sanstha-all-details/sanstha-all-details.module').then(m => m.SansthaAllDetailsModule)
    },
    {
        path: 'govardhan-applicant-details',
        loadChildren: () => import('./modules/govardhan-applicant-details/govardhan-applicant-details.module').then(m => m.GovardhanApplicantDetailsModule)
    },
    {
        path: 'new-scheme-application-list',
        loadChildren: () => import('./modules/new-scheme-application-list/new-scheme-application-list.module').then(m => m.NewSchemeApplicationListModule)
    },
    {
        path: 'maharashtra-government-application-list',
        loadChildren: () => import('./modules/maharashtra-government-application-list/maharashtra-government-application-list.module').then(m => m.MaharashtraGovernmentApplicationListModule)
    },
    {
        path: 'change-password',
        loadChildren: () => import('./modules/change-password/change-password.module').then(m => m.ChangePasswordModule)
    },
    {
        path: '**',
        redirectTo: ''
    }

];
